import React from 'react'
import { Route, useRouteMatch } from 'react-router-dom'
import { RecordRoute } from '../../../../shared/page/record-route'
import { OrganizationList } from './page/organization-list'
import { OrganizationAdd } from './page/organization-add'
import { OrganizationEdit } from './page/organization-edit'
import { OrganizationSso } from './page/organization-edit/organization-sso'
import { ProviderEdit } from '../provider/page/provider-edit'
import { OrganizationRecycle } from './page/organization-recycle'
import { OrganizationExtend } from './page/organization-extend'
import { Delete } from '../../../../shared/page/page-delete'
import { Purge } from '../../../../shared/page/page-purge'
import { useApiFormOrganization } from '../../../../api-new/state/content'
import { useApiFormProvider } from '../../../../api-new/state/auth'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { ORGANIZATION_SSO_TAB } from './organization-breadcrumb'

// The SSO tab's page only on its own address. Under it (a connection opened
// from the tab) the tab is just its crumb: its data is not read behind the
// connection's page.
const OrganizationSsoRoute = () => {
  const { isExact } = useRouteMatch()
  return isExact ? <OrganizationSso /> : <BreadcrumbView Icon={ORGANIZATION_SSO_TAB.Icon} text={ORGANIZATION_SSO_TAB.text} />
}

export const LayoutOrganization = () => {
  return (
    <React.Fragment>
      <Route path="/admin/organization/list" component={OrganizationList} />
      <Route path="/admin/organization/list/add" component={OrganizationAdd} />
      <RecordRoute path="/admin/organization/list/edit/:organizationID" component={OrganizationEdit} />
      <Route path="/admin/organization/list/edit/:organizationID/sso" component={OrganizationSsoRoute} />
      {/* One of the organization's connections, opened from its SSO tab: the
          same workspace as /admin/sso/connections/:providerID, under the
          organization so the trail and the highlight stay with it. */}
      <RecordRoute path="/admin/organization/list/edit/:organizationID/sso/connections/:providerID(\d+)" component={ProviderEdit} />
      {/* Deleting that connection returns to the organization's SSO tab. */}
      <RecordRoute path="/admin/organization/list/edit/:organizationID/sso/connections/:deleteID(\d+)/delete">
        <Delete useApiForm={useApiFormProvider} titleParam="providerName" successPath="/admin/organization/list/edit/:organizationID/sso" />
      </RecordRoute>
      <RecordRoute path="/admin/organization/list/edit/:deleteID/delete">
        <Delete useApiForm={useApiFormOrganization} titleParam="name" successPath="/admin/organization/list" />
      </RecordRoute>
      <Route path="/admin/organization/list/recycle" component={OrganizationRecycle} />
      <RecordRoute path="/admin/organization/list/recycle/purge/:purgeID">
        <Purge
          useApiForm={useApiFormOrganization}
          titleParam="name"
          successPath="/admin/organization/list/recycle"
          showServerError
          buttonText="purge now"
          successMessage="Purge scheduled. The hourly job will purge it."
        />
      </RecordRoute>
      <RecordRoute path="/admin/organization/list/recycle/extend/:extendID" component={OrganizationExtend} />
    </React.Fragment>
  )
}
